import { render, staticRenderFns } from "./AiPage.vue?vue&type=template&id=4858005e&scoped=true&"
import script from "./AiPage.vue?vue&type=script&lang=js&"
export * from "./AiPage.vue?vue&type=script&lang=js&"
import style0 from "./page.css?vue&type=style&index=0&id=4858005e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4858005e",
  null
  
)

export default component.exports